/**
 * Conditional Access Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoginDetails } from './loginDetails';


export interface TestPoliciesModel { 
    loginDetails?: LoginDetails;
    machineName?: string | null;
    osPlatform?: string | null;
    os?: string | null;
    osVersion?: string | null;
    domainName?: string | null;
}

